'use client'

import Link from '@/lib/react-compat/link'
import { useI18n } from '@/components/i18n-provider'

export function Footer() {
  const { t } = useI18n()

  const quickLinks = [
    { name: t('header.nav.home'), href: '/' },
    { name: t('header.nav.recommendation'), href: '/recommendation' },
    { name: t('header.nav.yield'), href: '/yield-prediction' },
    { name: t('header.nav.disease'), href: '/disease-detection' },
    { name: t('header.nav.price'), href: '/price-prediction' },
    { name: t('header.nav.calendar'), href: '/calendar' },
  ]

  return (
    <footer className="border-t bg-muted/50">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-green-700">{t('footer.productTitle')}</h3>
            <p className="text-sm text-muted-foreground max-w-xs">{t('footer.productDesc')}</p>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold">{t('footer.contact')}</h4>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>{t('footer.email')}: qunqin2024@outlook.com</p>
              <p>{t('footer.phone')}: 18022929563</p>
              <p>{t('footer.address')}: 蓬江区环市街道胜利北路</p>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t text-center text-sm text-muted-foreground">
          <p>
            &copy; 2024 {t('brand')}. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  )
}
